export default __webpack_public_path__ + "static/media/deliland-sugar-icon.21147744.png";